import React, { Component } from "react";
import BuildRoundedIcon from '@material-ui/icons/BuildRounded';
import Fab from '@material-ui/core/Fab';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import { amber } from '@material-ui/core/colors';
import GridContainer from "../components/Grid/GridContainer";
import GridItem from "../components/Grid/GridItem";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: "center",
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    fabProgress: {
        color: amber[500],
        position: 'absolute',
        top: -6,
        left: -6,
        zIndex: 1,
        '&:hover': {
            color: green[500],
        },
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}));
const NotExist = () => {
    const classes = useStyles();
    return (
        <List  >
            <ListItem button className={classes.root}>
                <div className={classes.wrapper} style={{ padding: "20px" }} >
                    <Fab
                        aria-label="save"
                        // color="primary"
                        // className={buttonClassname}
                        style={{ width: "200px", height: "200px" }}
                    // size={"large"}
                    >
                        <BuildRoundedIcon style={{ width: "100px", height: "100px" }} />
                    </Fab>
                    <CircularProgress size={212} className={classes.fabProgress} style={{ textAlign: "center", padding: "20px" }} />

                </div>

            </ListItem>
            <div style={{ padding: "20px", textAlign: "center" }}>該問卷尚未設置完成，請致電 04-2255-2555 #168 企業健檢人員</div>
        </List>
    )
};


export default NotExist